import * as z from "zod";

export const setExtensivIntegration = {
  name: "setExtensivIntegration" as const,
  input: z
    .object({
      clientId: z.string().min(1, "Client ID is required"),
      clientSecret: z.string().min(1, "Client secret is required"),
      customerId: z
        .number()
        .int()
        .positive("Customer ID must be a positive number"),
      facilityId: z
        .number()
        .int()
        .positive("Facility ID must be a positive number"),
      userLogin: z.string().min(1).optional(),
      userLoginId: z.number().int().positive().optional(),
    })
    .refine((val) => val.userLogin != null || val.userLoginId != null, {
      message: "Either a user login or user login ID is required",
      path: ["userLogin"],
    }),
  output: z.object({}),
};

export type SetExtensivIntegrationInput = z.infer<
  typeof setExtensivIntegration.input
>;

export const updateExtensivIntegration = {
  name: "updateExtensivIntegration" as const,
  input: z.object({
    customerId: z.number().int().positive().optional(),
    facilityId: z.number().int().positive().optional(),
  }),
  output: z.object({}),
};

export type UpdateExtensivIntegrationInput = z.infer<
  typeof updateExtensivIntegration.input
>;

export const getExtensivIntegration = {
  name: "getExtensivIntegration" as const,
  input: z.object({}),
  output: z.object({
    extensivIntegration: z.optional(
      z.object({ customerId: z.number(), facilityId: z.number() }),
    ),
  }),
};

export type GetExtensivIntegrationOutput = z.infer<
  typeof getExtensivIntegration.output
>;

export const disconnectExtensivIntegration = {
  name: "disconnectExtensivIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
